import { makeAutoObservable } from 'mobx'
import * as R from 'ramda'

import TriggerChild from './TriggerChild'

class TriggerGroup {
    children

    constructor(triggerGroup, store, survey, skipLogic) {
        makeAutoObservable(this)
        this.store = store
        this.skipLogic = skipLogic
        Object.assign(this, triggerGroup)
        this.children = R.pathOr([], ['children'], triggerGroup).map(child => new TriggerChild(child, store, survey, this))
        console.log(`constructor TriggerGroup ${this.id} ${skipLogic}`)
    }

    removeChild(index) {
        console.log(`removeChild ${index}`)
        if (index > -1) {
            if (this.children[index].pendingUpdate) {
                this.pendingUpdate = true
            }
            this.children.splice(index, 1)
        }
    }

    updateTriggerOperator(index, operator) {
        this.children[index].updateTriggerOperator(operator)
    }

    updateTriggerGroupOperator(index, operator) {
        this.children[index].updateGroupOperator(operator)
    }

    updateGroupOperator(operator) {
        this.interGroupLogicalOperator = operator
    }

    addChild() {
        const child = new TriggerChild({
            interGroupLogicalOperator: 'AND',
            triggers: [],
        }, this.store, null, this)
        this.children.push(child)
        return child
    }

    addCondition(setY, pageQuestionId, setX, inheritedPageQuestionId) {
        let child = this.children.find(child => child.getPageQuestionId() === pageQuestionId)
        if (!child) {
            child = this.addChild()
            child.addTrigger(setY, pageQuestionId, setX, inheritedPageQuestionId)
        } else {
            child.addTrigger(setY, pageQuestionId, setX, inheritedPageQuestionId)
        }
    }

    addSurveyQuotaCondition = () => {
        let child = this.children.find(child => child.hasQuotaLogic())
        if (!child) {
            child = this.addChild()
            child.addSurveyQuotaTrigger()
        } else {
            child.addSurveyQuotaTrigger()
        }
    }

    addSurveyDateCondition = (surveyField) => {
        let child = this.children.find((child) => child.hasDateLogic(surveyField))
        if (!child) {
            child = this.addChild()
            child.addSurveyDateTrigger(surveyField)
        } else {
            child.addSurveyDateTrigger(surveyField)
        }
    }

    addHasResponseCondition = (pageQuestionId, setY) => {
        let child = this.children.find(child => child.getPageQuestionId() === pageQuestionId)
        if (!child) {
            child = this.addChild()
            child.addHasResponseTrigger(pageQuestionId, setY)
        } else {
            child.addHasResponseTrigger(pageQuestionId, setY)
        }
    }

    addNumericCondition = (pageQuestionId, equalityOperator, value, setY) => {
        let child = this.children.find(child => child.getPageQuestionId() === pageQuestionId)
        if (!child) {
            child = this.addChild()
            child.addNumericTrigger(pageQuestionId, equalityOperator, value, setY)
        } else {
            child.addNumericTrigger(pageQuestionId, equalityOperator, value, setY)
        }
    }

    triggerRemoved() {
        const childIndex = this.children.findIndex((child) => child.triggers.length === 0)
        if (childIndex > -1) {
            this.children.splice(childIndex, 1)
            this.skipLogic.triggerChildRemoved()
        }
    }

    toJSON() {
        const json = {
            children: this.children ? this.children.map(child => child.toJSON()) : [],
            interGroupLogicalOperator: this.interGroupLogicalOperator,
        }
        return json
    }
}

export default TriggerGroup
